import { z } from "zod";

export const LpResearchSourceSchema = z.discriminatedUnion("kind", [
	z.object({ kind: z.literal("pack"), ref: z.string().min(1) }).strict(),
	z.object({ kind: z.literal("intake"), ref: z.string().min(1) }).strict(),
	z.object({ kind: z.literal("web"), ref: z.url(), retrievedAt: z.iso.datetime() }).strict(),
]);
export type LpResearchSource = z.infer<typeof LpResearchSourceSchema>;

export const LpResearchClaimSchema = z
	.object({ text: z.string().min(1), source: LpResearchSourceSchema })
	.strict();
export type LpResearchClaim = z.infer<typeof LpResearchClaimSchema>;

export const LpResearchDraftSchema = z
	.object({
		market: z.array(LpResearchClaimSchema),
		audience: z.array(LpResearchClaimSchema),
		competitiveLandscape: z.array(LpResearchClaimSchema),
		constraints: z.array(LpResearchClaimSchema),
		competitors: z.array(
			z.object({ name: z.string().min(1), claims: z.array(LpResearchClaimSchema).min(1) }).strict(),
		),
	})
	.strict();
export type LpResearchDraft = z.infer<typeof LpResearchDraftSchema>;

export const LpCompetitorsSchema = z
	.object({ competitors: LpResearchDraftSchema.shape.competitors })
	.strict();
export const LpConstraintsSchema = z
	.object({ constraints: z.array(LpResearchClaimSchema) })
	.strict();
